import {Component, Input, OnInit} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {firstValueFrom, forkJoin} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {SvgLoaderComponent, SafeResourcePipe, LocalService} from "lib-base";
import {ButtonDirective} from "primeng/button";

@Component({
  selector: 'app-instructivo',
  standalone: true,
  imports: [
    DialogModule,
    SvgLoaderComponent,
    SafeResourcePipe,
    ButtonDirective
  ],
  templateUrl: './instructivo.component.html',
  styleUrl: './instructivo.component.scss'
})
export class InstructivoComponent implements OnInit {

  @Input() visible: boolean = false;
  items: any[] = [];
  translations: any = {};

  constructor(private _t: TranslateService, private _ls: LocalService) {
  }

  ngOnInit(): void {
    this.initTranslations().then(
      () => this.initItems()
    );
  }


  async initTranslations(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin(
      {
        title: this._t.get('components.app-instructivo.title'),
        titleComplemento: this._t.get('components.app-instructivo.subtitle'),
        subtitle: this._t.get('components.app-instructivo.description'),
        btnClose: this._t.get('components.app-instructivo.button'),
        item1Bold: this._t.get('components.app-instructivo.item-1.bold'),
        item1Normal: this._t.get('components.app-instructivo.item-1.normal'),
        item2Bold: this._t.get('components.app-instructivo.item-2.bold'),
        item2Normal: this._t.get('components.app-instructivo.item-2.normal'),
        item3Bold: this._t.get('components.app-instructivo.item-3.bold'),
        item3Normal: this._t.get('components.app-instructivo.item-3.normal'),
        item4Bold: this._t.get('components.app-instructivo.item-4.bold'),
        item4Normal: this._t.get('components.app-instructivo.item-4.normal'),
        item5Bold: this._t.get('components.app-instructivo.item-5.bold'),
        item5Normal: this._t.get('components.app-instructivo.item-5.normal'),
        item6Bold: this._t.get('components.app-instructivo.item-6.bold'),
        item6Normal: this._t.get('components.app-instructivo.item-6.normal'),
      }));
  }

  initItems(): void {
    this.items = [
      {
      icon: 'pi pi-search',
      html: `
      <p class="my-0">
        <span class="font-bold">${this.translations.item1Bold}</span>
            ${this.translations.item1Normal}
      </p>`
    },
      {
        icon: 'pi pi-user-plus',
        html: `
      <p class="my-0">
        <span class="font-bold">${this.translations.item2Bold}</span>
            ${this.translations.item2Normal}
      </p>`
      },
      {
        icon: 'pi pi-list-check',
        html: `
      <p class="my-0">
        <span class="font-bold">${this.translations.item3Bold}</span>
            ${this.translations.item3Normal}
      </p>`
      },
      {
        icon: 'pi pi-pen-to-square',
        html: `
      <p class="my-0">
        <span class="font-bold">${this.translations.item4Bold}</span>
            ${this.translations.item4Normal}
      </p>`
      },
      {
        icon: 'pi pi-dollar',
        html: `
         <p class="my-0">
        <span class="font-bold">${this.translations.item5Bold}</span>
            ${this.translations.item5Normal}
      </p>`
      },
      {
        icon: 'pi pi-chart-line',
        html: `
      <p class="my-0">
        <span class="font-bold">${this.translations.item6Bold}</span>
            ${this.translations.item6Normal}
      </p>`
      },
    ];

  }

  onHide(): void {
    this._ls.showInstructivo = false;
  }
}
